import { render, staticRenderFns } from "./NextMatches.vue?vue&type=template&id=4f56c400&scoped=true&"
import script from "./NextMatches.vue?vue&type=script&lang=js&"
export * from "./NextMatches.vue?vue&type=script&lang=js&"
import style0 from "./NextMatches.vue?vue&type=style&index=0&id=4f56c400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56c400",
  null
  
)

export default component.exports